import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Card,
  Link,
  Typography,
  Container,
  Stack,
  styled
} from '@mui/material';

import { useTranslation } from 'react-i18next';
import { ReactComponent as GarlicLogo } from 'src/layouts/ExtendedSidebarLayout/Sidebar/garlic.svg';

import { Helmet } from 'react-helmet-async';
import JWTLogin from '../LoginJWT';


const MainContent = styled(Box)(
  () => `
    height: 100%;
    display: flex;
    flex: 1;
    flex-direction: column;
`
);

const TopWrapper = styled(Box)(
  () => `
  display: flex;
  width: 100%;
  flex: 1;
  padding: 20px;
`
);

function LoginBasic() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Login</title>
      </Helmet>
      <MainContent>
        <TopWrapper>
          <Container maxWidth="sm">
            <Stack mt={3} direction="row" justifyContent="center">
              <GarlicLogo />
            </Stack>
            <Card
              sx={{
                mt: 3,
                px: 4,
                pt: 5,
                pb: 3
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    mb: 1
                  }}
                >
                  {t('Connexion')}
                </Typography>
                <Typography
                  variant="h4"
                  color="text.secondary"
                  fontWeight="normal"
                  sx={{
                    mb: 3
                  }}
                >
                  {t('Merci de renseigner les champs suivants.')}
                </Typography>
              </Box>
              <JWTLogin />
              <Box my={4}>
                <Typography
                  component="span"
                  variant="subtitle2"
                  color="text.primary"
                  fontWeight="bold"
                >
                  {t('Pas encore inscrit ?')}
                </Typography>{' '}
                <Link component={RouterLink} to="/account/register-basic">
                  <b>M'inscrire maintenant</b>
                </Link>
              </Box>
            </Card>
          </Container>
        </TopWrapper>
      </MainContent>
    </>
  );
}

export default LoginBasic;
